<template>

</template>

<script>
    export default {
      name: "WrongURL",
      created() {
        this.$router.push('/dashboard');
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/WrongURL.vue